/**
 * 角色列表页面路径
 */
export const ROLE_LIST_PAGE_PATH = '/role/list'

/**
 * 角色创建页面路径
 */
export const ROLE_CREATE_PAGE_PATH = '/role/create'

/**
 * 角色编辑页面路径
 */
export const ROLE_EDIT_PAGE_PATH = '/role/edit'

/**
 * 角色详情页面路径
 */
export const ROLE_DETAIL_PAGE_PATH = '/role/detail'
